import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'retailer_mobile-close_bottom_nav-click';

/**
 * Retailer hits the 'X' or taps outside to close the Bottom Nav. PRD - https://www.notion.so/faire/mWeb-bottom-nav-e289d4aa07d640bfa07019c14a532303
 */
export function trackRetailerMobileCloseBottomNavClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
